var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEngine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_20",
    "data-name": "Group 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 114.443,
    height: 91.603,
    viewBox: "0 0 114.443 91.603",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114",
    "data-name": "Rectangle 114",
    width: 114.443,
    height: 91.603,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M33.219,15.889H41.23a.433.433,0,0,0,.434-.432V8.292a.431.431,0,0,1,.432-.432h12.45a.433.433,0,0,0,.432-.434V.432A.432.432,0,0,0,54.545,0H19.9a.431.431,0,0,0-.432.432V7.426a.432.432,0,0,0,.432.434h12.45a.432.432,0,0,1,.432.432v7.165a.432.432,0,0,0,.432.432",
    transform: "translate(18.743 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M35.428,17.737l11.51,11.512a5.513,5.513,0,0,1,0,7.8L41.9,42.09a5.52,5.52,0,0,1-7.8,0L22.585,30.578A19.179,19.179,0,1,0,35.428,17.737",
    transform: "translate(20.961 16.294)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M34.89,42.88,52.039,60.028A9.079,9.079,0,1,0,64.879,47.189L47.731,30.039A19.2,19.2,0,0,1,34.89,42.88m26.482,8.527a3.616,3.616,0,1,1-5.114,0,3.615,3.615,0,0,1,5.114,0",
    transform: "translate(33.582 28.914)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M114.011,20.888h-7a.432.432,0,0,0-.432.432v4.963a.432.432,0,0,1-.432.432H96.173a.432.432,0,0,1-.432-.432V19.83a.433.433,0,0,0-.432-.434H84.995a.433.433,0,0,1-.359-.19l-6.043-8.969a.435.435,0,0,0-.359-.19H34.362a.437.437,0,0,0-.341.167l-9.5,12.268a.433.433,0,0,1-.341.169H16.491a.432.432,0,0,0-.432.432V33.77a.431.431,0,0,1-.432.432H8.294a.431.431,0,0,1-.432-.432V21.32a.432.432,0,0,0-.434-.432H.434A.432.432,0,0,0,0,21.32V55.96a.432.432,0,0,0,.434.432H7.428a.432.432,0,0,0,.434-.432V43.51a.432.432,0,0,1,.432-.432h7.334a.432.432,0,0,1,.432.432V54.741a.433.433,0,0,0,.432.432H26.775a.427.427,0,0,1,.322.145L37.68,67.225A.433.433,0,0,0,38,67.37H71.187l-4.274-4.276a21.063,21.063,0,0,1-5,.6,20.967,20.967,0,0,1-20.081-27l.86-2.871L56.326,47.447a3.734,3.734,0,0,0,5.275,0l5.034-5.036a3.732,3.732,0,0,0,0-5.273L53,23.506l2.871-.862A20.984,20.984,0,0,1,82.283,47.722l10.07,10.07,4.412-4.914a.439.439,0,0,1,.322-.143h9.065a.432.432,0,0,1,.432.432V55.96a.432.432,0,0,0,.432.432h7a.431.431,0,0,0,.432-.432V21.32a.431.431,0,0,0-.432-.432",
    transform: "translate(0 9.671)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngine);
export default __webpack_public_path__ + "static/media/engine.0bf252c417f0adbac3d28725eacdeed4.svg";
export { ForwardRef as ReactComponent };